import styled from 'styled-components';

const Label = styled.div`
  color: ${({ theme }) => theme.atlas.text.secondary};
  font-size: ${({ theme }) => theme.basic.fontSizes.small};
`;

export default Label;
